import type { CoverableDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/quote';
import { useState } from 'react';
import StringTitle from './StringTitle';
import { useRecoilState, useRecoilValue } from 'recoil';
import { Grid, GridItem, DateField } from '@flos/react-ui';
import type { ExternaleCaseDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/policyjob/edi/dto';
import { convertDateToLocalDateDTO, convertLocalDateDTOToDate } from '../../../utils/dateUtil';
import { externalCasesAtom } from '../../../recoil/atoms/externalCasesAtom';
import {
    updateExternalCaseDTOProperties,
    dateHasValidationErrors
} from '../../../utils/externalCasesUtil';
import EDIValidationErrorMessage from './EDIValidationErrorMessage';
import { useHippoText } from '../../../hooks/useHippoText';
import { sortedCoverablesListSelector } from '../../../recoil/selectors/sortedCoverablesListSelector';

const EDICancellationNo = ({
    externalCase,
    coverable
}: {
    externalCase: ExternaleCaseDTO;
    coverable: CoverableDTO;
}): React.JSX.Element => {
    const getHippoText = useHippoText();
    const { startDate, caseId } = externalCase;
    const [externalCaseDTOList, setExternalCaseDTOList] = useRecoilState(externalCasesAtom);
    const { sortedCoverables } = useRecoilValue(sortedCoverablesListSelector);
    const [showErrorMessage, setShowErrorMessage] = useState(
        startDate ? dateHasValidationErrors(startDate, coverable, sortedCoverables, true) : false
    );
    if (!caseId) return <></>;

    const onStartDateChange = (date: Date): void => {
        const startDate = convertDateToLocalDateDTO(date);
        const updatedExternalCaseProperties = updateExternalCaseDTOProperties(
            externalCaseDTOList,
            [caseId],
            {
                startDate
            }
        );
        setExternalCaseDTOList(updatedExternalCaseProperties);
        setShowErrorMessage(dateHasValidationErrors(startDate, coverable, sortedCoverables, true));
    };

    return (
        <Grid gap={7}>
            <GridItem span={12} className="u-spacing-stack-top-5">
                <StringTitle space={true}>
                    {getHippoText('DSS-EFFECTIVE-DATE-AND-CANCELLATION-NO-CANCELLATION-SUBHEADER')}
                </StringTitle>
                <DateField
                    selected={startDate ? convertLocalDateDTOToDate(startDate) : undefined}
                    label="Vælg dato"
                    id={`no-datefield-${String(caseId)}`}
                    onChange={onStartDateChange}
                    minDate={new Date()}
                    dateFormat="dd. MMMM yyyy"
                />
            </GridItem>

            {showErrorMessage && (
                <GridItem span={12}>
                    <EDIValidationErrorMessage coverable={coverable} isStartDate />
                </GridItem>
            )}
        </Grid>
    );
};

export default EDICancellationNo;
